/**
 * UI-side mirror of the API `DaysOfWeekFlags` `[Flags]` enum. A bitmask of the days an office
 * notification can be scheduled on. All seven days are represented for completeness, but scheduling is
 * restricted to weekdays (Mon–Fri) — Saturday and Sunday are never selectable in the UI or accepted by
 * API validation.
 */
export enum DaysOfWeekFlags {
  None = 0,
  Sun = 1,
  Mon = 2,
  Tue = 4,
  Wed = 8,
  Thu = 16,
  Fri = 32,
  Sat = 64,
}
